module.exports = __webpack_public_path__ + "img/report-6.3c9650b7.jpg";